import React, { createContext, useEffect, useState } from 'react'
import { TestTakerPopup } from '.'
import Papa from 'papaparse';
import schoolsFile from 'mock/Schools.csv';
import mockSchools from 'mock/schools'

const CreateTestTakerPopup = () => {
    const [schools, setSchools] = useState(null)
    const [errorList, setErrorList] = useState([])
    const cleanState = () => window.history.replaceState({}, '')

    useEffect(() => {
        if (!schools)
            fetch(schoolsFile)
                .then(response => response.text())
                .then(csvData => {
                    Papa.parse(csvData, {
                        header: true,
                        complete: (results) => {
                            setSchools([...mockSchools, ...results.data])
                        },
                        error: (error) => {
                            console.error('CSV Parsing Error:', error);
                        }
                    });
                })
                .catch(error => {
                    console.error('Error fetching CSV file:', error);
                });
    }, [])

    useEffect(() => {
        window.addEventListener("beforeunload", cleanState);
        return () => {
            window.removeEventListener("beforeunload", cleanState);
        };
    }, []);

    let commonValue = {
        schools,
        errorList, setErrorList
    }

    return (
        <CreateTestTakersContext.Provider value={commonValue}>
            <TestTakerPopup />
        </CreateTestTakersContext.Provider>
    )
}

export const CreateTestTakersContext = createContext()
export default CreateTestTakerPopup